var map = {
	"./admin/32px.png": 8852,
	"./admin/40px.png": 63926,
	"./admin/android-chrome-72x72.png": 58996,
	"./admin/green.png": 79029,
	"./admin/green@2x.png": 46578,
	"./admin/patterns/4.png": 33686,
	"./admin/patterns/header-profile-skin-1.png": 19193,
	"./admin/patterns/header-profile-skin-2.png": 65705,
	"./admin/patterns/header-profile-skin-3.png": 24478,
	"./admin/patterns/header-profile.png": 39986,
	"./admin/patterns/otis_redding.png": 85884,
	"./admin/patterns/shattered.png": 71750,
	"./admin/profile.jpg": 81076,
	"./admin/profile_big.jpg": 98652,
	"./admin/profile_small.jpg": 13854,
	"./fav.svg": 31674,
	"./icons/popup_close.svg": 15798,
	"./logo.svg": 60724,
	"./noimage/large.png": 59691,
	"./noimage/mini.png": 70764,
	"./noimage/product.png": 92619,
	"./noimage/small.png": 88128,
	"./oba.svg": 13485,
	"./og.png": 40822,
	"./social/fb.svg": 60937,
	"./social/fb_a.svg": 34823,
	"./social/inst.svg": 42563,
	"./social/yt.svg": 51616,
	"admin/32px.png": 8852,
	"admin/40px.png": 63926,
	"admin/android-chrome-72x72.png": 58996,
	"admin/green.png": 79029,
	"admin/green@2x.png": 46578,
	"admin/patterns/4.png": 33686,
	"admin/patterns/header-profile-skin-1.png": 19193,
	"admin/patterns/header-profile-skin-2.png": 65705,
	"admin/patterns/header-profile-skin-3.png": 24478,
	"admin/patterns/header-profile.png": 39986,
	"admin/patterns/otis_redding.png": 85884,
	"admin/patterns/shattered.png": 71750,
	"admin/profile.jpg": 81076,
	"admin/profile_big.jpg": 98652,
	"admin/profile_small.jpg": 13854,
	"fav.svg": 31674,
	"icons/popup_close.svg": 15798,
	"images/admin/32px.png": 8852,
	"images/admin/40px.png": 63926,
	"images/admin/android-chrome-72x72.png": 58996,
	"images/admin/green.png": 79029,
	"images/admin/green@2x.png": 46578,
	"images/admin/patterns/4.png": 33686,
	"images/admin/patterns/header-profile-skin-1.png": 19193,
	"images/admin/patterns/header-profile-skin-2.png": 65705,
	"images/admin/patterns/header-profile-skin-3.png": 24478,
	"images/admin/patterns/header-profile.png": 39986,
	"images/admin/patterns/otis_redding.png": 85884,
	"images/admin/patterns/shattered.png": 71750,
	"images/admin/profile.jpg": 81076,
	"images/admin/profile_big.jpg": 98652,
	"images/admin/profile_small.jpg": 13854,
	"images/fav.svg": 31674,
	"images/icons/popup_close.svg": 15798,
	"images/logo.svg": 60724,
	"images/noimage/large.png": 59691,
	"images/noimage/mini.png": 70764,
	"images/noimage/product.png": 92619,
	"images/noimage/small.png": 88128,
	"images/oba.svg": 13485,
	"images/og.png": 40822,
	"images/social/fb.svg": 60937,
	"images/social/fb_a.svg": 34823,
	"images/social/inst.svg": 42563,
	"images/social/yt.svg": 51616,
	"logo.svg": 60724,
	"noimage/large.png": 59691,
	"noimage/mini.png": 70764,
	"noimage/product.png": 92619,
	"noimage/small.png": 88128,
	"oba.svg": 13485,
	"og.png": 40822,
	"social/fb.svg": 60937,
	"social/fb_a.svg": 34823,
	"social/inst.svg": 42563,
	"social/yt.svg": 51616
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80608;